import Text from 'components/Text/Text';
import React, { useContext, useRef } from 'react';
import { allApkTypes } from 'appConstants';
import { Select } from 'antd';
import {
	ApkAssignmentContext,
	IApkAssignmentContext,
} from 'modules/FirmwareAndApp/Apk/ApkAssignment/apkAssignmentState/apkAssignmentContext';
import style from './ApkTypeSelect.module.scss';

const { Option } = Select;

const ApkTypeSelect: React.FC = () => {
	const { changeTypeApk, IDSelectedTypeApk } = useContext<IApkAssignmentContext>(ApkAssignmentContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);

	return (
		<div className={style.container} data-test="ApkTypeSelect">
			<Text
				translationNameSpace="listing"
				translationKey="applicationApkTypeLabel"
				theme="neutralLight"
				size="xs"
			/>
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={changeTypeApk}
				value={IDSelectedTypeApk}
				listItemHeight={allApkTypes.length}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}>
				{allApkTypes.length ? (
					<>
						<Option value={null}>
							<Text translationNameSpace="listing" translationKey="allTypesLabel" asFragment={true} />
						</Option>
						{allApkTypes.map((el) => (
							<Option className={style.listItem} value={el.apkTypeID} key={el.apkTypeID}>
								{el.apkTypeName}
							</Option>
						))}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default ApkTypeSelect;
